import { feedbackApi } from '@/request';

/**
 * 聊天举报反馈服务
 */
class FeedbackServer {
  constructor() {
    if (typeof FeedbackServer.instance === 'object') {
      return FeedbackServer.instance;
    }

    this.state = {};
  }

  // 用户创建举报
  createFeedback(data = {}, options = {}) {
    return feedbackApi.createFeedback(data, options)
  }
  // 获取理由列表
  getReportReasonList(data = {}, options = {}) {
    return feedbackApi.getReportReasonList(data, options)
  }

}

export default function useFeedbackServer() {
  if (!useFeedbackServer.instance) {
    useFeedbackServer.instance = new FeedbackServer();
  }

  return useFeedbackServer.instance;
}
